import { render } from "./[id].vue?vue&type=template&id=3080a8c6&scoped=true"
import script from "./[id].vue?vue&type=script&lang=js"
export * from "./[id].vue?vue&type=script&lang=js"

import "./[id].vue?vue&type=style&index=0&id=3080a8c6&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3080a8c6"]])

export default __exports__